import { AppThunk } from "appThunk";

import { loadAddress } from "modules/customer/tools/location/locationSlice";
import { RetailCentreWithScores } from "modules/customer/tools/location/retailCentre";
import { Target } from "modules/customer/tools/location/target";
import { logError } from "modules/helpers/logger/loggerSlice";

export interface Coordinates {
    latitude: number,
    longitude: number
}

export class SuggestedNewLocation {
    public readonly id: number;
    public readonly address: string;
    public readonly coordinates: Coordinates;
    public readonly overallScore: number;

    constructor(
        id: number,
        address: string,
        coordinates: Coordinates,
        overallScore: number
    ) {
        this.id = id;
        this.address = address;
        this.coordinates = coordinates;
        this.overallScore = overallScore;
    }
}

export const loadSuggestedNewLocations = (retailCentresWithScores: RetailCentreWithScores[], target?: Target): AppThunk<Promise<SuggestedNewLocation[]>> => async (dispatch) => {
    try {
        if (retailCentresWithScores.length === 0 || !retailCentresWithScores || !target) {
            return [];
        }

        const sortedRetailCentresWithAlignmentScore = retailCentresWithScores
            .sort((a, b) => b.overallScore - a.overallScore)
            .slice(0, 100);

        const addressesPromise = sortedRetailCentresWithAlignmentScore.map(rc => {
            return (dispatch(loadAddress(rc.latitude, rc.longitude)));
        });
        const addresses = await Promise.all(addressesPromise);

        const suggestedNewLocations: SuggestedNewLocation[] = [];
        for (let i = 0; i < sortedRetailCentresWithAlignmentScore.length; i++) {
            const address = addresses[i];
            const retailCentre = sortedRetailCentresWithAlignmentScore[i];
            const coordinates: Coordinates = {
                latitude: retailCentre.latitude,
                longitude: retailCentre.longitude
            };
            const suggestedNewLocation = new SuggestedNewLocation(
                retailCentre.id,
                address,
                coordinates,
                retailCentre.overallScore
            );
            suggestedNewLocations.push(suggestedNewLocation);
        }
        return suggestedNewLocations;
    } catch (error) {
        dispatch(logError("Error loading Suggested New Locations.", error));
        throw error;
    }
};
